module.exports = __webpack_public_path__ + "static/media/hub_large.9343c99b.svg";